import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IOnGetCatalogsDTO from "../models/DTO/IOnGetCatalogsDTO";

const getCatalogs = async (userModel: IUserUI, supplierModel: ISupplierModel, vendorModel?: IVendorModel): Promise<IOnGetCatalogsDTO> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.CatalogsGetCatalogs,
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch catalogs: ${response.statusText}`);
    }

    return (await response.json()) as IOnGetCatalogsDTO;
};

const CatalogService = {
    getCatalogs,
};

export default CatalogService;
